/******/ (() => { // webpackBootstrap
/*!*************************!*\
  !*** ./src/js/login.js ***!
  \*************************/
/*
* LM: Display forgotten password content & form.
*/
function resetPasswordForm() {
  var passwordFormToggle = document.getElementById("RecoverPassword"),
    signInFormToggle = document.getElementById("SignIn"),
    loginForm = document.getElementById("CustomerLoginForm"),
    passwordForm = document.getElementById("RecoverPasswordForm"),
    urlHash = window.location.hash;
  function toggleResetPassword() {
    if (passwordForm.classList.contains("hidden")) {
      passwordForm.classList.remove("hidden");
      loginForm.classList.add("hidden");

      //Scroll to top
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });

      //Update URL
      //Get the current URL without links
      var currentURLWithoutParams = window.location.href.split('#')[0];
      //update the page url with link
      history.pushState(null, null, currentURLWithoutParams + '#recover');
    } else {
      passwordForm.classList.add("hidden");
      loginForm.classList.remove("hidden");

      //Update URL
      //Get the current URL without links
      var currentURLWithoutParams = window.location.href.split('#')[0];
      //update the page url with link
      history.pushState(null, null, currentURLWithoutParams);
    }
  }
  if (urlHash === '#recover') {
    toggleResetPassword();
  }
  passwordFormToggle.addEventListener("click", function (e) {
    e.preventDefault();
    toggleResetPassword();
  });
  signInFormToggle.addEventListener("click", function (e) {
    e.preventDefault();
    toggleResetPassword();
  });
}
function resetPasswordFormSuccess() {
  var resetPasswordSuccess = document.getElementById("reset-password-success"),
    loginForm = document.getElementById("CustomerLoginForm"),
    passwordForm = document.getElementById("RecoverPasswordForm");
  if (typeof resetPasswordSuccess != 'undefined' && resetPasswordSuccess != null) {
    loginForm.classList.add("hidden");
    passwordForm.classList.remove("hidden");
  }
}
resetPasswordForm();
resetPasswordFormSuccess();
/******/ })()
;